import { render, staticRenderFns } from "./SupercardFreeItemPromotionForm.vue?vue&type=template&id=45d4ab04&"
import script from "./SupercardFreeItemPromotionForm.vue?vue&type=script&lang=js&"
export * from "./SupercardFreeItemPromotionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports